import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { getStackVendorSettingsUrl } from "shared/Stack/OpenTofuMigration/helpers";
import { OpenTofuMigrateStackNode } from "shared/Stack/OpenTofuMigration/gql";

const OpenTofuMigrationReadyToMigrateTableNameCell = ({
  item: stack,
  ...cellProps
}: TableSimpleCellProps<OpenTofuMigrateStackNode>) => (
  <TableSimpleCell {...cellProps} role="rowheader">
    <TableCellLink href={getStackVendorSettingsUrl(stack.id)}>{stack.name}</TableCellLink>
  </TableSimpleCell>
);

export default OpenTofuMigrationReadyToMigrateTableNameCell;
